package com.milta.core.auth

import kotlinx.browser.localStorage

/**
 * Kotlin/JS implementation of [TokenStorage] — browser `localStorage`, via `kotlinx.browser`
 * (built into kotlin-stdlib-js, no extra dependency). Unlike [AndroidTokenStorage]
 * (`EncryptedSharedPreferences`), `localStorage` is not encrypted at rest — accepted for the web
 * dashboard bootstrap; revisit (e.g. httpOnly cookie minted by the backend) if token sensitivity
 * on this target requires it.
 */
class JsTokenStorage : TokenStorage {

    override fun saveTokens(accessToken: String, refreshToken: String) {
        localStorage.setItem(KEY_ACCESS_TOKEN, accessToken)
        localStorage.setItem(KEY_REFRESH_TOKEN, refreshToken)
    }

    override fun getAccessToken(): String? = localStorage.getItem(KEY_ACCESS_TOKEN)
    override fun getRefreshToken(): String? = localStorage.getItem(KEY_REFRESH_TOKEN)

    override fun clear() {
        localStorage.removeItem(KEY_ACCESS_TOKEN)
        localStorage.removeItem(KEY_REFRESH_TOKEN)
    }

    private companion object {
        const val KEY_ACCESS_TOKEN = "milta_access_token"
        const val KEY_REFRESH_TOKEN = "milta_refresh_token"
    }
}
